export const USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION = 'USER_REQUEST_LOCATION_IS_FETCHING_GEOLOCATION';
export const USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS = 'USER_REQUEST_LOCATION_FETCH_GEOLOCATION_SUCCESS';
export const USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE = 'USER_REQUEST_LOCATION_FETCH_GEOLOCATION_FAILURE';



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/userRequestLocation/events.js